/* eslint-disable camelcase */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_for_yoga_teachers_and_seasoned_practitioners_we_offer_comprehensive_education_to_advance_your: Phrase =
  locale => {
    const en = `For yoga teachers and seasoned practitioners, we offer comprehensive education to advance your yoga career and curated challenges to reignite your personal practice.`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `Para profesores de yoga y practicantes experimentados, ofrecemos una educación integral para avanzar en su carrera de yoga y desafíos para reactivar su práctica personal.`,
    };
    return phrases[locale] || en;
  };
